<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='pageSearchChange'
        layout='inline'>
        <a-form-item>
          <a-radio-group v-model:value="search.day_type" button-style="solid" @change="onChangeDay">
            <a-radio-button :value="1">最近7天</a-radio-button>
            <a-radio-button :value="2">最近30天</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="" name=''>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class="s_flex_bian_c m-b-40">
        <div class="width70 ">
          <div class="s_bf58 bor-rad-5 height-130 s_flex_bian_c m-b-10">
            <div class="width33">
              <p class="fz-30 s_c333 text-ac ">{{dataTotal.user_count_all}}</p>
              <p class="fz-16 s_c333 text-ac">下单人数</p>
            </div>
            <div class="width33 s_cd0d_bl1">
              <p class="fz-30 s_c333 text-ac ">{{dataTotal.order_count_all}}</p>
              <p class="fz-16 s_c333 text-ac">下单笔数</p>
            </div>
            <div class="width33 s_cd0d_bl1">
              <p class="fz-30 s_c333 text-ac ">{{dataTotal.order_total_all}}</p>
              <p class="fz-16 s_c333 text-ac">下单金额</p>
            </div>
          </div>
          <div class=" s_bf58 bor-rad-5 height-130 s_flex_bian_c">
            <div class="width33">
              <p class="fz-30 s_c333 text-ac ">{{dataTotal.user_pay_count_all}}</p>
              <p class="fz-16 s_c333 text-ac">付款人数</p>
            </div>
            <div class="width33 s_cd0d_bl1">
              <p class="fz-30 s_c333 text-ac ">{{dataTotal.order_pay_count_all}}</p>
              <p class="fz-16 s_c333 text-ac">付款订单数</p>
            </div>
            <div class="width33 s_cd0d_bl1">
              <p class="fz-30 s_c333 text-ac ">{{dataTotal.order_pay_total_all}}</p>
              <p class="fz-16 s_c333 text-ac">付款金额</p>
            </div>
          </div>
        </div>
        <div class="width28 s_bf58 bor-rad-5">
          <div class="s_flex_center" style="height: 270px;">
            <div>
              <p class="fz-30 s_cd41 text-ac s_font_b">{{dataTotal.percentage}}</p>
              <p class="fz-16 s_c333 s_flex_center">
                付款转化率
                <a-tooltip>
                  <template #title>
                    付款转化率＝（付款订单数／下单笔数）X 100%
                  </template>
                  <QuestionCircleOutlined class="s_c376 m-l-5" />
                </a-tooltip>
              </p>
            </div>
          </div>
        </div>
      </div>
      <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
    </a-card>
  </a-layout>
</template>
<script>
  import { QuestionCircleOutlined } from '@ant-design/icons-vue';
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { getOrderStatisticsPoint } from "@/api/order";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  let defSearch = {
    start_time: '',
    end_time: '',
    day_type: 1
  };
  export default {
    components: {  QuestionCircleOutlined },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        dataTotal: {},
        time: [],
        echartData: {},
        listLoading: true
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const onChangeDay = () => {
        search.value.start_time = "";
        search.value.end_time = "";
        state.time = [];
        initData(search.value);
      }
      const onChange = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
        search.value.day_type = 0
      }
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getOrderStatisticsPoint(values).then(res => res.data);
        if (iscode(res)) {
          res.data.latelyDays = res.data.date
          res.data.dataName = ['付款人数', '付款订单数', '付款金额','付款转化率（%）']
          res.data.series = [
            {
              name: '付款人数',
              data: res.data.user_pay_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '付款订单数',
              data: res.data.order_pay_count,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '付款金额',
              data: res.data.order_pay_total,
              type: 'line',
              symbolSize: 6,smooth: true
            },
            {
              name: '付款转化率（%）',
              data: res.data.percentages,
              type: 'line',
              symbolSize: 6,smooth: true
            }
          ]
          state.echartData = res.data;
          state.dataTotal = res.data.dataTotal
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      // 页面筛选项搜索
      const pageSearchChange = () => {
        initData(search.value);
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        onChangeDay,
        onChange,
        pageSearchChange
      };
    },
  };
</script>
<style> 
.s_cd0d_bl1{border-left: 1px solid #D0D9E3;}
</style>